import React from 'react'
import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import { UserReview } from '../UserReview'
import styles from './List.module.css'
import { ListLoading } from './ListLoading'
import { NoReviewsMessage } from './NoReviewsMessage'
import { ShowMoreReviewsButton } from './ShowMoreReviewsButton'

export function List() {
  const { reviewPages, hasNextPage, isFetching, isFetchingNextPage, reviewsAmount } = useUserReviews()

  if (isFetching && !isFetchingNextPage) {
    return <ListLoading />
  }

  if (!reviewsAmount) {
    return <NoReviewsMessage />
  }

  return (
    <div className={styles.wrapper}>
      {reviewPages.map((reviewPage, index) => (
        <React.Fragment key={index}>
          {reviewPage?.reviews?.map(review => <UserReview key={review.id} {...review} />)}
        </React.Fragment>
      ))}
      {isFetchingNextPage && <ListLoading />}
      {hasNextPage && <ShowMoreReviewsButton />}
    </div>
  )
}
